import { TrophyAwardIcon } from './TrophyAwardIcon';

/**
 * author: Doug C. Hardester
 * id 39F70CE8-5C56-4AAB-A4F7-93F871B1CB96
 * name trophy-award
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/trophy-award.svg
 * tags
 * - Sport 
 */
export const AchievementAwardIcon = TrophyAwardIcon;
export default AchievementAwardIcon